import BaseViewController from "./base-view-controller";

class FilterViewController extends BaseViewController {
  preprocessAppData() {
    this.appData.handleSwitchChange = this.handleSwitchChange;
    this.appData.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    super.preprocessAppData();
  }

  preprocessScreenData() {
    this.screen.footerFields.forEach(field => {
      if (field.name === "resetButton") {
        field.action = {
          type: "dialog",
          title: "Are you sure?",
          actions: [{ label: "Reset", onClick: this.resetFilters }]
        };
      }
    });
  }

  handleButtonClick(name, text, action) {
    if (name === "saveButton") {
      this.appData.prevScreen();
    } else if (name === "resetButton") {
      this.appData.resetFilters();
      this.appData.prevScreen();
    } else {
      super.handleButtonClick(name, text, action);
    }
  }

  resetFilters = () => {
    this.nextScreenHandler();
    this.appData.resetFilters();
  };

  nextScreenHandler = () => {
    this.appData.nextScreen({
      data: this.appData.data,
      formState: this.appData.values,
      action: {
        type: "screen",
        value: this.appData.data.screens.find(
          s => s.name === "ConsultationBhNewProvider"
        ).identifier
      }
    });
  };

  handleCheckboxClick(filterName, checked, value) {
    const filterValues = this.appData.providerFilters.filters[filterName];
    if (checked) {
      this.appData.setFilters({ [filterName]: [...filterValues, value] });
    } else {
      const clonedValues = [...filterValues];
      if (clonedValues.indexOf(value) !== -1) {
        clonedValues.splice(clonedValues.indexOf(value), 1);
      }
      this.appData.setFilters({ [filterName]: clonedValues });
    }
  }

  handleSwitchChange = (name, option) => {
    this.appData.setFilters({ [name]: option.name === "Y" });
  };
}

export default FilterViewController;
